import {Component, Input, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {InventoryBarcodeSearchPageComponent} from "../inventory-barcode-search-page/inventory-barcode-search-page.component";

export class InventoryBarcodeReportSelectionData extends EntityData<InventoryBarcodeReportSelectionData> {
    @identifier inventoryBarcodeId: number;
    @field inventoryId: number;
    @field name: string;
    @field size: string;
    @field barcode: string;
    @field amount: number;
    @field symbol: string;
    @field qty: number = 1;
}

@Component({
    selector: "wbo-inventory-barcode-report-selection",
    templateUrl: "./inventory-barcode-report-selection-control.component.html"
})
export class InventoryBarcodeReportSelectionControlComponent {

    InventoryBarcodeSearchPageComponent = InventoryBarcodeSearchPageComponent;

    fieldName: string = "barcodes";

    /**
     * Indicates of the quantity column should be shown
     */
    @Input() editQty: boolean;

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromInventory(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((inventory: any) => inventory.inventoryBarcodeId === item.inventoryBarcodeId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
